import IMAGES from "@/public/assets/img";

const MachineryLoanData = {
  seoData: {
    title: "Machinery Loan for Exporters: Upgrade & Expand Globally",
    description:
      "Exporters can now get fast machinery loans and boost production. Upgrade equipment and expand your global trade with flexible financing solutions from Credlix.",
    keywords:
      "machinery loan, equipment finance, export business loan, manufacturing loan, QCO compliance, Make in India, business expansion, modern equipment, production capacity, scale ambition, Credlix.",
  },
  bannerHeading: "Your Export Ambition​",
  subheading: "Deserves Better Machinery",
  btntext: "We Make it Happen",
  paraLoan:'Fast, Flexible Loans from <span class="font-medium">₹50L to ₹10Cr</span> <span class="font-semibold text-[36px] sm:text-xl">for Exporters Ready to Scale</span>',

  loanInfo: [
    {
      icon: IMAGES?.MachineryLoan.tenureupto,
      description: "Tenure up to 36 months",
    },
    {
      icon: IMAGES?.MachineryLoan.competitiveInterest,
      description: "Competitive interest rates (12 - 15% p.a)",
    },
    {
      icon: IMAGES?.MachineryLoan.loanSignificant,
      description: "Loan for Significant upgrades/ Expansion",
    },
  ],

  Challenge: {
    sectionTitle: "The Exporter’s Challenge",
    mainHeading: "Overcoming Operational Bottlenecks",
    description:
      "Outdated machinery causes production bottlenecks, compromised quality, missed deadlines, and order rejections.<br/> New Quality Control Orders (QCOs) mandate compliance non-upgrade risks legal penalties, recalls, and reputational damage.",
    subSectionTitle: "Fueling Your Manufacturing Prowess",
    subSectionDescription:
      "Credlix Machinery Loans offer fast, collateral-minimized financing from ₹50 Lakh to ₹10 Crore with 12–15% p.a. interest and approvals in 48–72 hours.",
    include: "Benefits include:",
    benefits: [
      {
        icon: IMAGES?.MachineryLoan.enchanced,
        text: "Enhanced capacity to fulfill larger orders and meet global timelines",
      },
      {
        icon: IMAGES?.MachineryLoan.compliance,
        text: "Compliance with international standards and QCO regulations",
      },
      {
        icon: IMAGES?.MachineryLoan.strategic,
        text: "Strategic investment in future-proof, energy-efficient equipment",
      },
      {
        icon: IMAGES?.MachineryLoan.ethos,
        text: "Alignment with “Make in India for the World” ethos",
      },
    ],
  },

  HowItWorks: {
    heading: "How It Works",
    subHeading: "Your Path to Modernization​",
    steps: [
      {
        id: "1",
        para: "Share Business Details and vendor quotations. ​",
      },
      {
        id: "2",
        para: "Get Swift Approval minimal delays.​",
      },
      {
        id: "3",
        para: "Receive Funds to acquire or upgrade machinery. ​",
      },
    ],
  },

  buyerCredit: {
    sectionTitle: "Know Before you Trade",
    mainHeading: "Credlix offers real-time, detailed, and in-depth",
    mainSubHeading: "analysis of your buyers",
    benefits: [
      {
        icon: IMAGES?.MachineryLoan.creditcheck,
        text: "Real Time Credit Check",
      },
      {
        icon: IMAGES?.MachineryLoan.reports,
        text: "Detailed Reports",
      },
      {
        icon: IMAGES?.MachineryLoan.analysis,
        text: "In-Depth Analysis​",
      },
    ],
  },

  bannerCTA: {
    title: "Ready to Power Up? Your Future Awaits!",
    description:
      "Unlock enhanced production, ensure compliance, and secure your competitive edge in international markets.",
    button: {
      label: "Apply Now for Machinery Loans",
      link: "/apply-machinery-loan",
    },
  },

  FaqHead: "Frequently Asked Questions (FAQs)",
  Faq: [
    {
      id: 0,
      question: "What is a Machinery Loan?",
      answers:
        "A business loan for acquiring or upgrading essential equipment.",
    },
    {
      id: 1,
      question: "How much can I borrow?",
      answers: "₹50 Lakh to ₹10 Crore, based on eligibility.",
    },
    {
      id: 2,
      question: "What are the interest rates and terms?",
      answers:
        "12%–15% p.a., tenures up to 36 months with flexible moratoriums.",
    },
    {
      id: 3,
      question: "Is collateral required?",
      answers: "Minimized—machinery may serve as security in select cases.",
    },
    {
      id: 4,
      question: "How fast is approval?",
      answers: "Typically within 48–72 hours.",
    },
    {
      id: 5,
      question: "Can I finance used machinery?",
      answers:
        "Focus is on modern equipment; policies for used assets available on inquiry.",
    },
    {
      id: 6,
      question: "Which machinery qualifies?",
      answers:
        "Yes, export financing can be used for both goods and services. ",
    },
    {
      id: 7,
      question: "What are the advantages of Export Financing?",
      answers:
        "Equipment across engineering, plastics, food processing, textiles, and more.",
    },
    {
      id: 8,
      question: "How does this support QCO compliance?",
      answers:
        "Enables purchase of compliant machinery to meet government quality standards.",
    },
    {
      id: 9,
      question: "Are there hidden charges?",
      answers: "Transparent fee structure—no surprises.",
    },
  ],
};
export default MachineryLoanData;
